<script lang="ts" setup>
definePageMeta({
  layout: 'basic'
})
</script>

<template>
  <section class="p-5 flex-col-center text-base text-center text-neutral-800">
    <Icon class="mb-10 text-primary-500" name="solar:check-read-line-duotone" alt="Icon" width="96" height="96" />

    <h1 class="mb-4 text-3xl font-medium">
      Payment successful
    </h1>

    <p class="max-w-500px opacity-80 leading-snug">
      You can now close this page and return to the app.
    </p>
  </section>
</template>
